import * as R from 'ramda';
import { requestWithAuthorization } from './requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import { ImportJobStatus } from '@/utils/consts';

export const getImportJobStatus = async (
  tenant: string,
  landscape: string
): Promise<ImportJobStatus> => {
  const response = await requestWithAuthorization
    .get(`${portalConfigure.API.getImportJobStatus}/${tenant}/${landscape}`)
    .catch(error => {
      const status = R.path(['response', 'status'], error);
      const data = R.path(['response', 'data'], error);
      if (status !== 404) {
        if (data) {
          error.message = JSON.stringify(data);
        }
        throw error;
      }
    });
  const data = R.path(['data', 'progress'], response);
  return data as ImportJobStatus;
};
